// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oauthProviderConfigurationModal__BxF34J_nOE{width:800px;max-width:100%}`, "",{"version":3,"sources":["webpack://./src/app/components/appModals/components/oauthProviderConfigurationModal/oauthProviderConfigurationModal.module.scss"],"names":[],"mappings":"AAAA,6CACE,WAAA,CACA,cAAA","sourcesContent":[".oauthProviderConfigurationModal {\n  width: 800px;\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"oauthProviderConfigurationModal": `oauthProviderConfigurationModal__BxF34J_nOE`
};
export default ___CSS_LOADER_EXPORT___;
